import { useState } from "react";

import PersonIcon from "@mui/icons-material/PersonAddAltRounded";
import { Box, Button, Typography } from "@mui/material";

import { ClientResponse } from "@/api";
import { Assign1bAppointmentDialog } from "@/common/components/appointments/assign-1b/Assign1bAppointmentDialog";
import { ClientCreationDialog } from "@/pages/clients/client/components/create-client/ClientCreationDialog";
import { useTranslation } from "@/translations";

import { ClientsSearch } from "./components/search/ClientsSearch";

interface Props {
  numberOfClients: number;
  hasAdditionalClients: boolean;
  /** Suppresses the result count: a failed search knows of no clients, it did not find none. */
  isError: boolean;
}

export function ClientsHeader({ numberOfClients, hasAdditionalClients, isError }: Props) {
  const { t } = useTranslation();
  const [showClientCreationDialog, setShowClientCreationDialog] = useState<boolean>(false);
  const [createdClient, setCreatedClient] = useState<ClientResponse | null>(null);

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
      <Box>
        <Typography variant="h1">
          {isError ? t("clients.titleUnavailable") : t("clients.title", { count: numberOfClients })}
        </Typography>
        {hasAdditionalClients && <Typography variant="subtitle1">{t("clients.subtitle")}</Typography>}
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <Button
          variant="outlined"
          startIcon={<PersonIcon sx={{ color: "fsw.blue" }} />}
          onClick={() => {
            setShowClientCreationDialog(true);
          }}
        >
          {t("clients.createClient")}
        </Button>
        <ClientsSearch />
      </Box>
      {showClientCreationDialog && (
        <ClientCreationDialog
          onClose={() => setShowClientCreationDialog(false)}
          onClientCreated={(client) => setCreatedClient(client)}
        />
      )}
      {createdClient && <Assign1bAppointmentDialog client={createdClient} onClose={() => setCreatedClient(null)} />}
    </Box>
  );
}
